<template>
    <div>
        <div class="accleft">
            <div class="ugico"></div>
            <div class="con" v-if="user">
                <h2>{{ user.name }}</h2>
                <div class="count"><span>FXB<i></i></span><b>{{ user.amt }}</b></div>
                <div class="count"><span>积分<i></i></span><b class="g">{{ user.integral }}</b></div>

                <span class="sign signin" title="已签到" v-if="user.is_sign && user.is_sign===true"><i></i>已签</span>
                <span class="sign" title="签到送积分" v-else @click="toSign"><i></i>签到</span>
            </div>
            <div class="con" v-else>
                <div class="btn"><router-link to="/login">登录</router-link>/<router-link to="/register">注册</router-link></div>
            </div>
        </div>

        <div class="acclfnav">
            <template v-if="user">
            <router-link v-for="(c,i) in navList" :key="i" :to="c.url" :class="['lk',i===0?'mt':'']">
                <i :class="c.icon"></i>{{c.name}}<span v-if="i===4" class="cp"><router-link to="/coupon">领券</router-link></span>
            </router-link>
            </template>

            <router-link to="/about" class="lk mt"><i class="icon_ab"/>关于我们</router-link>
            <router-link to="/mianze" class="lk"><i class="icon_mz"/>免责声明</router-link>
            <router-link to="/treaty" class="lk"><i class="icon_ct"/>用户协议</router-link>
            <router-link to="/help" class="lk"><i class="icon_hp"/>帮助中心</router-link>
            <router-link to="/contact" class="lk"><i class="icon_ct"/>联系我们</router-link>

            <div class="btn">
            <button v-if="user" type="button" @click="loginOut">安全退出</button>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "my",
        props: ['data'],
        computed: mapGetters(['user']),
        data() {
            return {
                // user: null,
                navList: [
                    {
                        name: '购物车',
                        url: '/cart',
                        icon: 'cr'
                    },
                    {
                        name: '订阅记录',
                        url: '/account/subscribe',
                        icon: 'c2'
                    },
                    {
                        name: '交易记录',
                        url: '/account/cost',
                        icon: 'c1'
                    },
                    {
                        name: '账号资料',
                        url: '/account/info',
                        icon: 'c3'
                    },
                    {
                        name: '我的优惠',
                        url: '/account/coupon',
                        icon: 'yh'
                    },
                    {
                        name: '在线充值',
                        url: '/account/recharge',
                        icon: 'c4'
                    }
                ]
            }
        },
        watch: {
            // '$route': {
            //     handler () {
            //         document.documentElement.scrollTop = this.$route.meta.y
            //     }
            // },
          // data(v){
          //     if(v===null){
          //         this.$router.push('/login')
          //     }
          // }
        },
        activated() {
            let that = this
            //加载读取用户信息
            if(this.$store.state.token){
                this.$post(false, that.$api.getUserInfo).then(function (res) {
                    if(res.code === 1){
                        that.$store.commit('SET_USER', res.data.user)
                    }
                })
            }

        },
        methods: {
            toSign: function () {
                let that = this
                that.$post(that.$api.sign).then(function (res) {
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        let user = that.user
                        if(that.user === null) {
                            user = {}
                        }
                        user.is_sign = true
                        user.integral = res.data.integral
                        that.$store.commit('SET_USER', user)
                    }
                    else {
                        that.$toast.fail(res.msg)
                    }
                })
            },
            loginOut: function(){
                let that = this
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定退出？',
                }).then( () => {
                    that.$store.commit('LOGOUT')
                    that.$route.meta.logout = true
                    that.$router.push('/ball')
                })
            },
        },
        // beforeRouteEnter(to, from, next){
        //     next(vm =>{
        //         document.documentElement.scrollTop = vm.$route.meta.y
        //     })
        // }
    }
</script>

<style scoped>
</style>
